import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { DayPicker, DateUtils } from 'react-day-picker';
import { bindActionCreators } from 'redux';
import { Button, Col, Row } from 'react-bootstrap';
import YearMonthForm from './AbsoluteDateDropDown';
import { toCustomDate } from '../../helpers/moment-ex';
import { setSearchParams } from '../../actions/analyze';
import { RANGE_TYPE_CUSTOM, RANGE_TYPE_ABSOLUTE, RANGE_TYPE_TODAY, RANGE_TYPE_YESTERDAY } from '../../constants';
import 'react-day-picker/lib/style.css';
import '../../../assets/scss/daterangepicker.scss';

const AbsoluteDate = (props) => {
    const { searchParams, setShow, farmId, timezoneIdentifier } = props;
    const numberOfMonths = 2;
    const todayDate = moment().format("DD MMM YYY");
    // const currentYear = new Date().getFullYear();   get current year

    const initialRange = {
        from: new Date(searchParams.custom.from),
        to: new Date(searchParams.custom.to),
    };

    const initialCalendarRange = {
        from: new Date(moment(searchParams.custom.from).year(), 0),
        to: new Date(moment(searchParams.custom.from).year(), 11)
    };

    const [range, setRange] = useState(initialRange);
    const [years, setYears] = useState();
    const [calendarRange, setCalendarRange] = useState(initialCalendarRange);
    const [isDisable, setDisable] = useState(false);
    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [currentFarmId, setFarmId] = useState(farmId);

    const { from, to } = range;
    const modifiers = { start: from, end: to, foo: new Date() };

    // useEffect(() => {
    //     setRange({
    //         from: new Date(searchParams.custom.from),          enable to set custom selected value in absolute calendar selection
    //         to: new Date(searchParams.custom.to)  
    //     })
    // }, [searchParams]);

    useEffect(() => {
        if (currentFarmId !== farmId) {
            setRange({ from: new Date(), to: new Date() });
            setYears(new Date());
            setFarmId(farmId);
        }
    }, [farmId]);

    useEffect(() => {
        const date = searchParams.custom.from;
        const year = moment(date).year();
        const month = moment(date).format("M");
        if (searchParams.customRange === "absolute" && searchParams.range === "custom") setYears(new Date(year, month - 1));

        setCalendarRange({
            from: new Date(year, 0),
            to: new Date(year, 11)
        });

        if (year !== selectedYear) {
            // setRange(initialRange);
            (range.from === undefined && range.to === undefined) ? setRange({ from: undefined, to: undefined }) : setRange(initialRange);

            const from = moment(searchParams.custom.from).format("DD MMM");
            const to = moment(searchParams.custom.to).format("DD MMM");
            //const today = moment(todayDate).format("DD MMM");
            const today = moment(todayDate, "DD MMM YYYY").format("DD MMM");

            if (from === to && from === today && selectedYear === moment().year()) setRange({ from: undefined, to: undefined });

            setSelectedYear(year);
            if (!(searchParams.customRange === "planned" || searchParams.customRange === "todate")) setYears(new Date(year, month - 1));
        }
    }, [searchParams]);

    useEffect(() => {
        (from && to) ? setDisable(false) : setDisable(true);
    }, [range]);

    const getMonth = (value, name) => {
        let newMonth = null;

        if (name === "month") {
            newMonth = value;
            setYears(new Date(selectedYear ? selectedYear : moment().year(), value));
        } else {
            setYears(new Date(value, newMonth));
        }
    };

    const handleDayClick = (day) => {
        const selectedRange = DateUtils.addDayToRange(day, range);
        setRange(selectedRange);
    };

    // const handleTodayButton = () => {
    //     setRange({ from: new Date(), to: new Date() });       // enable to go to today date by adding new button
    //     setYears(new Date());
    // }

    const handleResetClick = () => {
        setRange({ from: undefined, to: undefined });
    };

    const isQuickDate = (from, to) => {
        /* const now = moment.utc().tz(timezoneIdentifier);
          const today = moment(now).format("DD MMM YYYY");
          const isToday = (today === from);
          const isYesterday = moment(today).diff(from, 'days') === 1; */

        const now = moment.utc().tz(timezoneIdentifier);
        const today = now.format("DD MMM YYYY");
        const fromDate = moment(from, "DD MMM YYYY");
        const isToday = today === fromDate.format("DD MMM YYYY");
        const isYesterday = now.diff(fromDate, 'days') === 1;

        if (from === to) {
            if (isToday) {
                let obj = {
                    hasQuickDate: true,
                    rangeType: RANGE_TYPE_TODAY,
                    customRange: RANGE_TYPE_TODAY
                }
                return obj;
            }

            if (isYesterday) {
                let obj = {
                    hasQuickDate: true,
                    rangeType: RANGE_TYPE_YESTERDAY,
                    customRange: RANGE_TYPE_YESTERDAY
                }
                return obj;
            }
        }

        return { hasQuickDate: false }
    }

    const handleApply = (start, end) => {
        const from = range.from;
        const to = range.to;

        const fromDate = moment(from).startOf("days");
        const toDate = moment(to).endOf("days");

        const { hasQuickDate = false, rangeType, customRange } = isQuickDate(moment(from).format("DD MMM YYYY"), moment(to).format("DD MMM YYYY"));

        if (fromDate && toDate && !hasQuickDate) {
            const dateObj = toCustomDate(fromDate, toDate);
            props.actions.setSearchParams({
                range: RANGE_TYPE_CUSTOM, customRange: RANGE_TYPE_ABSOLUTE, custom: dateObj, absolute: dateObj
            });
        }

        if (fromDate && toDate && hasQuickDate) {
            const dateObj = toCustomDate(fromDate, toDate);
            props.actions.setSearchParams({
                range: rangeType, customRange: customRange, custom: dateObj, absolute: dateObj
            });
        }

        setShow();
    };

    const handleFullYear = () => {
        const isCurrentYear = selectedYear === moment().year();
        const from = new Date(`${selectedYear}-01-01`);
        const to = isCurrentYear ? new Date(`${selectedYear}-${moment().format('MM-DD')}`) : new Date(`${selectedYear}-12-31`);

        const fromDate = moment(from).startOf("days");
        const toDate = moment(to).endOf("days");

        if (fromDate && toDate) {
            const dateObj = toCustomDate(fromDate, toDate);
            props.actions.setSearchParams({
                range: RANGE_TYPE_CUSTOM, customRange: RANGE_TYPE_ABSOLUTE, custom: dateObj, absolute: dateObj
            });
        }
        setRange({ from, to });
        setShow();
    };

    const getFullAbsoluteYear = useMemo(() => {
        if (selectedYear !== moment().year()) return `Select 01 Jan to 31 Dec ${selectedYear}`;
        else {
            const todayDate = moment().format('DD MMM');
            return `Select 01 Jan to ${todayDate} ${selectedYear}`;
        }
    }, [selectedYear]);

    return (
        <div className="absoluteDate container">
            <Row>
                <Col className="YearNavigation">
                    <DayPicker
                        className="Selectable"
                        numberOfMonths={numberOfMonths}
                        selectedDays={[from, { from, to }]}
                        modifiers={modifiers}
                        // showOutsideDays  => enable to show next and previous month dates in current month
                        onDayClick={handleDayClick}
                        month={years}
                        fromMonth={calendarRange.from}
                        toMonth={calendarRange.to}
                        captionElement={({ date, localeUtils }) => (
                            <YearMonthForm
                                date={date}
                                getMonth={getMonth}
                                localeUtils={localeUtils}
                            />
                        )}
                    />
                </Col>
            </Row>
            <Row className="row justify-content-end w-100 pt-3 mt-5">
                <Col className='float-left col-auto' style={{ position: 'relative', right: '33%' }}>
                    <span
                        className="stretched-link"
                        onClick={(() => handleFullYear())}>
                        {getFullAbsoluteYear}
                    </span>
                </Col>
                <Col className="col-auto" style={{ textAlign: "end" }}>
                    <Button style={{ cursor: isDisable ? "not-allowed" : "pointer" }} className="btn btn-primary btn-sm mr-2" onClick={handleApply} disabled={isDisable}>Apply</Button>
                    <Button className="btn btn-danger btn-sm" onClick={handleResetClick}>Reset</Button>
                </Col>
            </Row>
        </div >
    );
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ setSearchParams }, dispatch)
});

const mapStateToProps = state => ({
    searchParams: state.analyze.searchParams,
    timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
});

export default connect(mapStateToProps, mapDispatchToProps)(AbsoluteDate);